module.exports = __webpack_public_path__ + "static/img/KINGSTON_PAINT.dfada1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/KINGSTON_PAINT.jpg
// module id = 0nQy
// module chunks = 0